// utils/pdfGenerator.js
export const generatePDF = (calculatedData, setGeneratingPDF) => {

    const fechaFormateada = new Date().toLocaleDateString('es-AR', {
  day: '2-digit',
  month: '2-digit', 
  year: 'numeric'
}).replace(/\//g, '-'); // Reemplazar las barras por guiones

const nombreEmpresaLimpio = (calculatedData.nombreEmpresa || 'Cliente')
  .replace(/\s+/g, '_')  // Reemplazar espacios por guiones bajos
  .replace(/[^\w\-]/g, '') // Remover caracteres especiales excepto guiones y guiones bajos
  .toLowerCase();


  setGeneratingPDF(true);

  // Importar jsPDF dinámicamente
  import('jspdf').then(({ jsPDF }) => {
    const doc = new jsPDF();

    // Configuración de fuentes y colores
    doc.setFont('helvetica');
    
    // Agregar logo como membrete
    const logoPath = '/logo.jpg';
    const logoWidth = 50; // 200px era demasiado grande para la página
    const logoHeight = 25; // Proporción ajustada
    const logoX = 20; // Posición izquierda
    
    try {
      // Agregar logo
      doc.addImage(logoPath, 'JPEG', logoX, 10, logoWidth, logoHeight);
    } catch (error) {
      console.warn('No se pudo cargar el logo:', error);
    }

    // Fecha de impresión (en la esquina superior derecha)
    doc.setFontSize(9);
    doc.setTextColor(102, 102, 102);
    const fechaImpresion = new Date().toLocaleDateString('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
    doc.text(`Fecha de impresión: ${fechaImpresion}`, 105, 15);

    // Encabezado - ajustado para dar espacio al logo
    doc.setFontSize(20);
    doc.setTextColor(51, 51, 51);
    doc.text('NOTIFICACIÓN DE AJUSTES TARIFARIOS', 105, 45, { align: 'center' });
    
    doc.setFontSize(14);
    doc.setTextColor(102, 126, 234);
    doc.text('Aumentos Progresivos de Servicios', 105, 55, { align: 'center' });

    // Línea separadora
    doc.setDrawColor(102, 126, 234);
    doc.setLineWidth(1);
    doc.line(20, 65, 190, 65);

    // Información de la empresa
    doc.setFontSize(12);
    doc.setTextColor(51, 51, 51);
    let yPos = 70;

    doc.setFont('helvetica', 'bold');
    doc.text('ESTIMADO CLIENTE:', 20, yPos);
    
    yPos += 10;
    doc.setFont('helvetica', 'normal');
    const textoIntroduccion = `Nos dirigimos a usted para informarle sobre los ajustes tarifarios que se implementarán de manera progresiva en nuestros servicios, debido a las fluctuaciones económicas actuales y el incremento en los costos operativos.`;
    
    const lineasIntro = doc.splitTextToSize(textoIntroduccion, 170);
    doc.text(lineasIntro, 20, yPos);
    yPos += lineasIntro.length * 6 + 10;

    // Datos del servicio
    doc.setFont('helvetica', 'bold');
    doc.setFillColor(248, 249, 250);
    doc.rect(20, yPos, 170, 40, 'F');
    doc.setTextColor(102, 126, 234);
    doc.text('DATOS DEL SERVICIO ACTUAL', 20, yPos + 10);
    
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(51, 51, 51);
    doc.text(`Empresa: ${calculatedData.nombreEmpresa || 'No especificada'}`, 25, yPos + 20);
    doc.text(`Horas mensuales: ${calculatedData.horasServicio || 'No especificadas'}`, 25, yPos + 28);
    doc.text(`Monto mensual actual: $${(calculatedData.montoBase * 1.21).toLocaleString('es-AR', {minimumFractionDigits: 2})} (Con IVA)`, 25, yPos + 36);

    yPos += 55;

    // Cronograma de aumentos
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(102, 126, 234);
    doc.text('CRONOGRAMA DE AJUSTES:', 20, yPos);
    yPos += 15;

    // Generar tabla de aumentos dinámicamente basado en el orden personalizado
    const mesesData = [];
    
    // Mapeo de nombres completos de meses
    const NOMBRES_MESES = {
      ene: 'Enero',
      feb: 'Febrero', 
      mar: 'Marzo',
      abr: 'Abril',
      may: 'Mayo',
      jun: 'Junio',
      jul: 'Julio',
      ago: 'Agosto',
      sep: 'Septiembre',
      oct: 'Octubre',
      nov: 'Noviembre',
      dic: 'Diciembre'
    };

    // Si tenemos meses ordenados, usarlos
    if (calculatedData.mesesOrdenados && Array.isArray(calculatedData.mesesOrdenados)) {
      calculatedData.mesesOrdenados.forEach(mes => {
        const mesKey = mes.key;
        const porcentajeKey = `porcentaje${mesKey.charAt(0).toUpperCase() + mesKey.slice(1)}`;
        const montoKey = `monto${mesKey.charAt(0).toUpperCase() + mesKey.slice(1)}`;
        
        const porcentajeIndividual = calculatedData[porcentajeKey] || 0;
        const montoSinIva = calculatedData[montoKey] || calculatedData.montoBase;
        
        if (porcentajeIndividual > 0) {
          mesesData.push({
            nombre: NOMBRES_MESES[mesKey] || mes.label,
            individual: porcentajeIndividual,
            montoSinIva: montoSinIva,
            montoConIva: montoSinIva * 1.21
          });
        }
      });
    } else {
      // Fallback: usar los meses originales si no hay orden personalizado
      const mesesOriginales = [
        { key: 'sep', nombre: 'Septiembre' },
        { key: 'oct', nombre: 'Octubre' },
        { key: 'nov', nombre: 'Noviembre' },
        { key: 'dic', nombre: 'Diciembre' },
        { key: 'ene', nombre: 'Enero' }
      ];

      mesesOriginales.forEach(mes => {
        const porcentajeKey = `porcentaje${mes.key.charAt(0).toUpperCase() + mes.key.slice(1)}`;
        const montoKey = `monto${mes.key.charAt(0).toUpperCase() + mes.key.slice(1)}`;
        
        const porcentajeIndividual = calculatedData[porcentajeKey] || 0;
        const montoSinIva = calculatedData[montoKey] || calculatedData.montoBase;
        
        if (porcentajeIndividual > 0) {
          mesesData.push({
            nombre: mes.nombre,
            individual: porcentajeIndividual,
            montoSinIva: montoSinIva,
            montoConIva: montoSinIva * 1.21
          });
        }
      });
    }

    // Encabezados de tabla
    doc.setFont('helvetica', 'bold');
    doc.setFillColor(102, 126, 234);
    doc.setTextColor(255, 255, 255);
    doc.rect(20, yPos, 170, 10, 'F');
    doc.text('MES', 25, yPos + 7);
    doc.text('% IND.', 60, yPos + 7);
    doc.text('SIN IVA', 90, yPos + 7);
    doc.text('CON IVA', 135, yPos + 7);
    yPos += 10;

    // Filas de datos
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(51, 51, 51);
    mesesData.forEach((mes, index) => {
      const bgColor = index % 2 === 0 ? [248, 249, 250] : [255, 255, 255];
      doc.setFillColor(bgColor[0], bgColor[1], bgColor[2]);
      doc.rect(20, yPos, 170, 8, 'F');
      
      doc.text(mes.nombre, 25, yPos + 5);
      doc.text(`+${mes.individual.toFixed(1)}%`, 60, yPos + 5);
      doc.text(`$${mes.montoSinIva.toLocaleString('es-AR', {minimumFractionDigits: 0})}`, 90, yPos + 5);
      doc.text(`$${mes.montoConIva.toLocaleString('es-AR', {minimumFractionDigits: 0})}`, 135, yPos + 5);
      yPos += 8;
    });

    yPos += 15;

    // Verificar si necesitamos una nueva página
    if (yPos > 250) {
      doc.addPage();
      yPos = 20;
    }

    // Texto de cierre
    const textoCierre = `Estos ajustes nos permitirán mantener la calidad de nuestros servicios y continuar brindándole la excelencia que nos caracteriza. Agradecemos su comprensión y quedamos a su disposición para cualquier consulta.`;
    const lineasCierre = doc.splitTextToSize(textoCierre, 170);
    doc.text(lineasCierre, 20, yPos);
    yPos += lineasCierre.length * 6 + 15;

    // Información de contacto
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(102, 126, 234);
    doc.text('CONTACTO:', 20, yPos);
    yPos += 8;
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(51, 51, 51);
    doc.text('Para consultas o aclaraciones, no dude en contactarnos.', 20, yPos);
    yPos += 6;
    doc.text('Estamos comprometidos con brindarle el mejor servicio.', 20, yPos);

    // Guardar el PDF
    const nombreArchivo = `${nombreEmpresaLimpio}_${fechaFormateada}.pdf`;
    doc.save(nombreArchivo);
    
    setGeneratingPDF(false);
  }).catch(error => {
    console.error('Error al cargar jsPDF:', error);
    alert('Error al generar el PDF. Por favor, intente nuevamente.');
    setGeneratingPDF(false);
  });
};